module.exports = __webpack_public_path__ + "img/Jump Casting129.cf6bc210.jpg";